import DividerLabel from './DividerLabel'

export default DividerLabel